import { colors } from '../../Colors/colors'

export const scoringTheme = {
   light: {
      common: {
         titleColor: 'text-gray-900',
         defaultBorderColor: 'border-gray-300',
         headerBgColor: 'bg-base-white',
         defaultBgColor: 'bg-gray-100',
         descriptionColor: 'text-gray-700',
         secondaryDescriptionColor: 'text-gray-500',
         refreshHandlerBgColor: '!bg-base-white',
         tooltipBgColor: 'bg-gray-900'
      },
      configStateToggle: {
         borderColor: 'border-gray-100',
         backgroundColor: 'bg-gray-100',
         color: 'text-gray-500',
         selected: {
            bgColor: 'bg-base-white',
            color: 'text-gray-700'
         },
         horizontalLineColor: 'border-gray-300'
      },
      scoringConfig: {
         sectionDividerColors: 'bg-gray-300 border-gray-300',
         verticalDividerColors: 'bg-gray-300',
         helpTextColors: 'text-gray-600',
         titleColors: 'text-gray-800',
         descriptionColors: 'text-gray-700'
      },
      scoringConfigStatus: {
         actionItemHoverColor: 'hover:bg-gray-50',
         actionItemTextColor: 'text-gray-700',
         badgeChevronActiveColor: colors['success-600'],
         badgeChevronInActiveColor: colors['gray-600'],
         statusActiveTextColor: 'text-success-700',
         statusInactiveTextColor: 'text-gray-700',
         helpTextColors: 'text-gray-600',
         titleColors: 'text-gray-800',
         descriptionColors: 'text-gray-700',
         addedTextColors: 'text-gray-500'
      },
      createParameter: {
         defaultTextColor: 'text-gray-600',
         descriptionTextColor: 'text-gray-700',
         subTextColor: 'text-gray-500'
      },
      createParameters: {
         sectionDividerColors: 'bg-gray-300 border-gray-300',
         footerColors: 'border-gray-300',
         titleColors: 'text-gray-800',
         descriptionColors: 'text-gray-600',
         descriptionTextColor: 'text-gray-700',
         subTextColor: 'text-gray-500'
      },
      recordScoreBadge: {
         borderColor: 'border-gray-300',
         scoreTextColor: 'text-gray-600',
         scoreValueColor: 'text-gray-800',
         totalPossibleScoreColor: 'text-gray-700'
      },
      scoreSort: {
         defaultBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         sortLabelColor: 'text-gray-800',
         chevronDownIconColor: colors['gray-500'],
         separatorBgColor: 'bg-gray-300'
      }
   },
   dark: {}
}
